import { ChangeFunctionType } from '@bookjane2/bookjane-design-library/lib/common.types';
import { ILocationFilterProps } from 'components/LocationFilterInput/LocationFilterInput.types';
import { FC, useMemo } from 'react';
import { withMemo } from 'utils/withMemo';
import { ParticipatingCommunitiesAttributes } from 'types/graphql';
import { BKJSSFBarSearchInputVariant } from 'components/BKJSSFBarSearchInput';
import { RequestTeamMemberForOrderProvider } from 'components/RequestTeamMemberForOrder/RequestTeamMemberForOrder.context';
import { RequestTeamMemberForOrderComponent } from 'components/RequestTeamMemberForOrder/RequestTeamMemberForOrder';
import { getShiftStartTimeAndEndTime } from 'components/RequestTeamMemberForOrder/RequestTeamMemberForOrder.utils';
import { getCurrentlySelectedLocation } from 'utils/getCurrentlySelectedLocation';

export interface IProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value'> {
  name: string;
  onChange: ChangeFunctionType;
  value: string;
  location: ILocationFilterProps['value'];
  orderId?: string;
  startDate?: string;
  startAt?: string;
  endAt?: string;
  breakTime?: string;
  allowOvertime?: boolean;
  byPosition?: number[];
  withParticipatingCommunities?: ParticipatingCommunitiesAttributes;
  variant?: BKJSSFBarSearchInputVariant;
}

const _RequestTeamMemberForOrder: FC<IProps> = (props) => {
  const { timeZone } = getCurrentlySelectedLocation();
  const [teamMemberStartAt, teamMemberEndAt] = useMemo(
    () =>
      getShiftStartTimeAndEndTime({
        startDate: props.startDate,
        startAt: props.startAt || '',
        endAt: props.endAt || '',
        timeZone,
      }),
    [props.endAt, props.startAt, props.startDate, timeZone],
  );
  return (
    <RequestTeamMemberForOrderProvider
      location={props.location}
      byPosition={props.byPosition}
      withParticipatingCommunities={props.withParticipatingCommunities}
      startTime={teamMemberStartAt}
      endTime={teamMemberEndAt}
      breakTime={props.breakTime}
      allowOvertime={props.allowOvertime}
      orderId={props.orderId}
    >
      <RequestTeamMemberForOrderComponent {...props} />
    </RequestTeamMemberForOrderProvider>
  );
};

export const RequestTeamMemberForOrder: FC<IProps> = withMemo(_RequestTeamMemberForOrder);
